import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const DeletePropertyUserModal = ({
  user,
  property,
  userProperty,
  confirmationHandler
}) => {
  const [showDeletePropertyUserModell, setShowDeletePropertyUserModel] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const userId = user.id;
  const userPropertyUserId = userProperty.user_id;
  const currentLoading = loading && userId === userPropertyUserId;

  return (
    <Fragment>
      {currentLoading ? (
        <div className='text-center'>
          <Spinner size='sm' animation='border' variant='danger' />
        </div>
      ) : (
        <Button
          type='button'
          variant='link'
          size='sm'
          className='text-danger'
          disabled={currentLoading}
          onClick={async () => {
            setShowDeletePropertyUserModel(true);
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      )}
      <Modal
        backdrop='static'
        show={showDeletePropertyUserModell}
        onHide={() => {
          setShowDeletePropertyUserModel(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you would like to delete the user <b>{user.name}</b>{' '}
            from the property <b>{property.name}</b>?
          </p>
          <Button
            variant='danger'
            onClick={async () => {
              setLoading(true);
              try {
                await confirmationHandler(userProperty.id);
              } catch (err) {
                if (process.env.NODE_ENV === 'development') console.error(err);
              }
              setLoading(false);
              setShowDeletePropertyUserModel(false);
            }}
          >
            {loading ? (
              <Spinner
                className='mx-3'
                animation='border'
                variant='success'
                size='sm'
              />
            ) : (
              'Confirm Delete'
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

DeletePropertyUserModal.propTypes = {
  user: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  userProperty: PropTypes.object.isRequired,
  confirmationHandler: PropTypes.func.isRequired
};

export default DeletePropertyUserModal;
